<template>
  <WizardContainer
    width="800px"
    height="500px"
  >
    <WizardContent
      :graphic="{
        type: 'gradient',
        assetsPath: 'ie-warning',
      }"
    >
      <h4 class="mt-6 mb-9 title-text">
        Internet Explorer <br> is not supported
      </h4>
      <p class="paragraph-text mb-6">
        Internet Explorer has been deprecated by Microsoft,
        and it is no longer supported by Datapeople.
        Please use one of the supported browsers listed below:
      </p>
      <ul class="no-bullets">
        <li
          v-for="browser in browsers"
          :key="browser"
          class="paragraph-text"
        >
          {{ browser }}
        </li>
      </ul>
      <WizardFooter>
        <h5 class="mt-6">
          Having Issues?
          <a
            :href="'mailto:hello@datapeople.io'
              + '?subject=Having%20issues%20with%20Internet%20Explorer%20on%20Datapeople'"
          >
            Contact Us
          </a>
        </h5>
      </WizardFooter>
    </WizardContent>
  </WizardContainer>
</template>

<script>
import WizardContainer from '@/components/shared/WizardContainer.vue';
import WizardContent from '@/components/shared/WizardContent.vue';
import WizardFooter from '@/components/shared/WizardFooter.vue';

export default {
  name: 'IEDeprecated',
  components: {
    WizardContainer,
    WizardContent,
    WizardFooter,
  },
  data() {
    return {
      browsers: [
        'Apple Safari',
        'Google Chrome',
        'Mozilla Firefox',
        'Microsoft Edge',
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.datapeople-app .title-text {
  font-weight: bold;
}

.datapeople-app .paragraph-text {
  font-size: 20px;
  line-height: 30px;
  color: @text-darkest;
  font-weight: 300;
  text-align: center;
  max-width: 400px;
}

ul.no-bullets {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
</style>
